module.exports = __webpack_public_path__ + "img/dashboard-xome-register.37a4f994.png";